import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "-9 -10 50 50"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m32 .007-6.21 8.126.013.026c1.87 2.714 3.142 5.638 3.142 9.15 0 8.113-6.48 14.691-14.472 14.691C6.48 32 0 25.422 0 17.31 0 9.197 6.27 2.563 14.263 2.563L16.38 0h5.744l-5.872 7.432-.042-.01a10 10 0 0 0-1.835-.171c-5.495 0-9.95 4.522-9.95 10.1 0 5.58 4.455 10.102 9.95 10.102 5.497 0 9.952-4.523 9.952-10.101 0-3.703-1.963-6.94-4.89-8.7h.031L26.322 0z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8.096 19.677h8.489l2.569-3.322v5.689l.009.01-1.883 2.357H8.096zM13.27 16.459l5.873-7.413v5.69l.01.01-1.34 1.713z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }